import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* 接口工具 */
import https from '@/utils/https'
import API from '@/utils/ApiUtils'

Vue.prototype.$post = https.post;
Vue.prototype.$get =  https.get;
Vue.prototype.$API = API;

/* element 组件 */
import 'element-ui/lib/theme-chalk/index.css';
import appHeader from '@/components/appHeader'
// 按需引入组件
import {
    Form,
    FormItem,
    Input,
    Button,
    Row,
    Col,
    Steps,
    Step,
    Upload,
    Breadcrumb,
    BreadcrumbItem,
    Pagination,
    Table,
    TableColumn,
    Tag,
    Loading,
    Message,
    MessageBox
} from 'element-ui';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
Vue.config.productionTip = false
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Upload);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tag);
Vue.use(Loading.directive);
Vue.component('appHeader', appHeader);
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;

/* 自定义组件 */
import CommonTitle from '@/common/commonTitle/CommonTitle';
import EmptyView from '@/components/empty/EmptyView';
Vue.component('CommonTitle', CommonTitle);
Vue.component('EmptyView', EmptyView);

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
